import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Funciona para acné hormonal?',
    a: 'Sí. El enfoque de RIMAN no es secar el grano (lo que daña la barrera), sino reparar la piel desde la raíz, equilibrar el sebo y calmar la inflamación. Es un proceso progresivo y muy efectivo para pieles con tendencia acneica.'
  }, {
    q: '¿Es para piel sensible?',
    a: 'Absolutamente. Los productos están formulados con ingredientes botánicos suaves y tecnología liposomal que permite que los activos penetren sin irritar la superficie de la piel.'
  }, {
    q: '¿Cómo compro desde Chile?',
    a: 'Puedes comprar directamente a través de mi enlace de asesora. Los productos llegan a la puerta de tu casa. Escríbeme y te ayudo a armar la rutina ideal para ti.'
  }, {
    q: '¿Cuánto tiempo para ver resultados?',
    a: 'La hidratación y luminosidad se notan desde la primera semana. Para cambios profundos en textura, manchas o acné, recomendamos ser constante por al menos 4 a 8 semanas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-white" data-id="element-13" data-mp="25h5fljdqyeme">
      <div className="container mx-auto px-6 md:px-12 max-w-3xl" data-id="element-14" data-mp="20p48sczclg3r">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-15" data-mp="20njaqddtrf15">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-4" data-id="element-16" data-mp="2odwyhrpdmrpx">
            Preguntas Frecuentes 💭
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-17" data-mp="tzvxb06ctsmo">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-brand-beige rounded-2xl overflow-hidden" data-id="element-18" data-mp="p1cbczrrggub" data-mpi={index}>
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-brand-cream/30 hover:bg-brand-cream transition-colors" data-id="element-19" data-mp="3318w88f514s1">
                <span className="font-serif text-lg font-medium text-brand-charcoal pr-8" data-id="element-20" data-mp="3htartga6dbm9">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-sage transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-21" data-mp="3mt5f79uqrj2k" />
              </button>
              <AnimatePresence data-id="element-22" data-mp="1k4no2ipqbdno">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-23" data-mp="1k2kop82os86a">
                    <div className="p-6 pt-0 text-brand-charcoal/70 font-light leading-relaxed bg-brand-cream/30" data-id="element-24" data-mp="1yvxoggv2zos5">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}